// extracted by mini-css-extract-plugin
module.exports = {"submitButton":"styles_submitButton__6bZCQ","agreementsWrapper":"styles_agreementsWrapper__pwrnL"};